import React from 'react';
import PropTypes from 'prop-types';

const IconBase = ({ children, color = '#fff', size = '1em', ...props }) => {
  return (
    <svg
      children={children}
      fill={color}
      preserveAspectRatio="xMidYMid meet"
      height={size}
      width={size}
      role="img"
      {...props}>
      {children}
    </svg>
  );
};

IconBase.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

export default IconBase;
